import { render, staticRenderFns } from "./apiRateLimit__form.vue?vue&type=template&id=11e59f0c"
import script from "./apiRateLimit__form.vue?vue&type=script&lang=js"
export * from "./apiRateLimit__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports